
$(document).ready(function () {
  function onScrollMobileAtc(event){
  event.preventDefault()
  var scrollPos = $(document).scrollTop();
  var buyButton = $('.mobile-button__anchor')
  var form  = $(".product-buy_buttons")
  const footer = $('.footer')
  if(buyButton){
    if(scrollPos - buyButton.height() > buyButton.offset().top-$(window).height() && footer.offset().top-footer.height() > scrollPos){
      form.addClass('active-float-button')
      form.css('display','block')
    }else{
      if( footer.offset().top-footer.height() < scrollPos){
        form.css('display','none')
      }
      form.removeClass('active-float-button')
    }
  }
}
	$(document).on("scroll", onScrollMobileAtc);
}); 
